export class TestSystemConnectionRequestODBC {
	username: string;
	password: string;
	connectionString: string;
	type: string;
	systemConnectionId?: string;

	constructor(
		username: string,
		password: string,
		connectionString: string,
		type: string,
		systemConnectionId?: string,
	) {
		this.username = username;
		this.password = password;
		this.connectionString = connectionString;
		this.type = type;
		this.systemConnectionId = systemConnectionId;
	}
}

export class TestSystemConnectionRequestOPCUA {
	username: string;
	password: string;
	opcuaUrl: string;
	sessionName: string;
	endpointMustExist: boolean;
	securityMode: string;
	securityPolicy: string;
	systemConnectionId?: string;

	constructor(
		username: string,
		password: string,
		opcuaUrl: string,
		sessionName: string,
		endpointMustExist: boolean,
		securityMode: string,
		securityPolicy: string,
		systemConnectionId?: string,
	) {
		this.username = username;
		this.password = password;
		this.opcuaUrl = opcuaUrl;
		this.sessionName = sessionName;
		this.endpointMustExist = endpointMustExist;
		this.securityMode = securityMode;
		this.securityPolicy = securityPolicy;
		this.systemConnectionId = systemConnectionId;
	}
}
